module.exports = __webpack_public_path__ + "static/media/Defult.45e1e072.jpg";